import { render } from "./ListDot.vue?vue&type=template&id=15e0b848&scoped=true"
import script from "./ListDot.vue?vue&type=script&lang=js"
export * from "./ListDot.vue?vue&type=script&lang=js"

import "./ListDot.vue?vue&type=style&index=0&id=15e0b848&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15e0b848"]])

export default __exports__